export default __webpack_public_path__ + "static/O0045-35b2a469eccd17cfd06edb8b4a4f3af3.png";